import {
  Datagrid,
  DateField,
  Filter,
  List,
  ResourceComponentProps,
  ShowButton,
  TextField,
  TextInput,
} from 'react-admin';
import React, { FC } from 'react';

export const OfferErrorsFilter: FC<ResourceComponentProps> = (props) => (
  <Filter {...props}>
    <TextInput label="Поиск по названию" source="title||$contL" alwaysOn />
  </Filter>
);

const OfferErrorsList = (props: ResourceComponentProps) => {
  return (
    <List filters={<OfferErrorsFilter />} {...props}>
      <Datagrid>
        <TextField label="Название" source="title" />
        <TextField label="Сообщение" source="message" />
        <DateField locales="rus" label="Создано" source="createdAt" />
        <DateField locales="rus" label="Изменено" source="updatedAt" />
        <ShowButton />
      </Datagrid>
    </List>
  );
};

export default OfferErrorsList;
